/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import * as Sentry from "@sentry/react";
import { ErrorBoundaryProps } from "@sentry/react";

export interface IErrorBoundaryProps {
	fallback?: React.ReactNode;
	beforeCapture?: ErrorBoundaryProps["beforeCapture"];
}

export const ErrorBoundary: React.FC<IErrorBoundaryProps> = ({ children, fallback, beforeCapture }) => (
	<Sentry.ErrorBoundary fallback={fallback ? <>{fallback}</> : undefined} beforeCapture={beforeCapture}>
		{children}
	</Sentry.ErrorBoundary>
);
